function refreshCart() {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        const sourceElement = html.querySelector(selector);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
    })
  .catch((e) => {
    console.error(e);
  });
}
Shopify.Cart = Shopify.Cart || {};
Shopify.Cart.GiftWrapTag = {};

Shopify.Cart.GiftWrapTag.addGiftProduct = function(TagGwpVariantId) {
  var headers = new Headers({ 'Content-Type': 'application/json' });

  // First, set the attribute
  fetch('/cart/update.js', {
    method: 'POST',
    headers,
    body: JSON.stringify({ attributes: { free_product_variant_id: TagGwpVariantId } })
  }).then(() => {
    // Then add the free product
    fetch('/cart/add.js', {
      method: 'POST',
      headers,
      body: JSON.stringify({ id: TagGwpVariantId, quantity: 1 })
    }).then(() => {
      const this_cartDrawer = document.querySelector('cart-drawer');
      this_cartDrawer.refresh(true);

      checkTagCond();
      checkTagQtyCond();
      checkGlobalTagGWPConditions();
      checkQuantityGlobalTagGWPConditions();
    });
  });
};
Shopify.Cart.GiftWrapTag.removeGiftProduct = function(TagGwpVariantId) {
  $.ajax({
    method: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data: {
      id: TagGwpVariantId,
      quantity: 0
    }
  }).then(() => {
    // Clear the attribute
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { free_product_variant_id: '' } })
    }).then(() => {
      const this_cartDrawer = document.querySelector('cart-drawer');
      this_cartDrawer.refresh(true);

      checkTagCond();
      checkTagQtyCond();
      checkGlobalTagGWPConditions();
      checkQuantityGlobalTagGWPConditions();
    });
  });
};

function checkTagCond() {
  const gwpInputs = document.querySelectorAll('.gwp_variant_new');
  if (!gwpInputs.length) return;

  jQuery.getJSON('/cart.js', function(cart) {
    gwpInputs.forEach(gwpInput => {
      const customTotal = parseInt(gwpInput.getAttribute('val'));
      const TagGwpVariantId = parseInt(gwpInput.getAttribute('tag-gwp_variant_id'));
      const TagGwpThreshold = parseInt(gwpInput.getAttribute('tag-gwp_threshold_price'));

      const giftInCart = cart.items.some(item => item.id === TagGwpVariantId);

      if (customTotal >= TagGwpThreshold && !giftInCart) {
        Shopify.Cart.GiftWrapTag.addGiftProduct(TagGwpVariantId);
        console.log(`Gift added for tag threshold: ${TagGwpThreshold}`);
      } else if (customTotal < TagGwpThreshold && giftInCart) {
  Shopify.Cart.GiftWrapTag.removeGiftProduct(TagGwpVariantId);
}
    });
  });
}

function checkTagQtyCond() {
  const gwpQtyInputs = document.querySelectorAll('.gwp_variant_tag_qty');
  if (!gwpQtyInputs.length) return;

  jQuery.getJSON('/cart.js', function(cart) {
    gwpQtyInputs.forEach(gwpQtyInputs => {
      const customQtyTotal = parseInt(gwpQtyInputs.getAttribute('val'));
      const TagGwpQtyVariantId = parseInt(gwpQtyInputs.getAttribute('tag-gwp_variant_tag_qty_id'));
      const TagGwpQtyThreshold = parseInt(gwpQtyInputs.getAttribute('tag-gwp_tag_qty'));

      const giftInCart = cart.items.some(item => item.id === TagGwpQtyVariantId);

      if (customQtyTotal >= TagGwpQtyThreshold && !giftInCart) {
        Shopify.Cart.GiftWrapTag.addGiftProduct(TagGwpQtyVariantId);
        console.log(`Gift added for tag threshold: ${TagGwpQtyThreshold}`);
      } else if (customQtyTotal < TagGwpQtyThreshold && giftInCart) {
        Shopify.Cart.GiftWrapTag.removeGiftProduct(TagGwpQtyVariantId);
        console.log(`Gift removed for tag threshold: ${TagGwpQtyThreshold}`);
      }
    });
  });
}
function checkGlobalTagGWPConditions() {
  const offerInputs = document.querySelectorAll('.special_offer_variant');
  if (!offerInputs.length) return;

  jQuery.getJSON('/cart.js', function(cart) {
    offerInputs.forEach(offerInput => {
      const currentTotal = parseInt(offerInput.getAttribute('value'));
      const OfferVariantId = parseInt(offerInput.getAttribute('data-global_tag-gwp-variant-id'));
      const OfferThreshold = parseInt(offerInput.getAttribute('data-global_tag-gwp-threshold-price'));
      const offerTag = offerInput.getAttribute('data-global_tag-gwp-tag');

      const freeItemInCart = cart.items.some(item => item.id === OfferVariantId);

      if (currentTotal >= OfferThreshold && !freeItemInCart) {
        Shopify.Cart.GiftWrapTag.addGiftProduct(OfferVariantId);
        console.log(`Global tag gift added for tag: ${offerTag}, threshold: ${OfferThreshold}`);
      } else if (currentTotal < OfferThreshold && freeItemInCart) {
        Shopify.Cart.GiftWrapTag.removeGiftProduct(OfferVariantId);
        console.log(`Global tag gift removed for tag: ${offerTag}, threshold: ${OfferThreshold}`);
      }
    });
  });
}

function checkQuantityGlobalTagGWPConditions() {
  const quantityOfferInputs = document.querySelectorAll('.quantity_offer_variant');
  if (!quantityOfferInputs.length) return;

  jQuery.getJSON('/cart.js', function(cart) {
    quantityOfferInputs.forEach(qtyOfferInput => {
      const currentQuantityTotal = parseInt(qtyOfferInput.getAttribute('value'));
      const OfferQtyVariantId = parseInt(qtyOfferInput.getAttribute('data-global_tag-gwp-variant-qty-id'));
      const OfferRequiredQty = parseInt(qtyOfferInput.getAttribute('data-global_tag-gwp-required-qty'));
      const offerTag = qtyOfferInput.getAttribute('data-global__quant_tag-gwp-tag');

      const freeItemInCart = cart.items.some(item => item.id === OfferQtyVariantId);

      if (currentQuantityTotal >= OfferRequiredQty && !freeItemInCart) {
        Shopify.Cart.GiftWrapTag.addGiftProduct(OfferQtyVariantId);
        console.log(`Global tag quantity gift added for tag: ${offerTag}, quantity: ${OfferRequiredQty}`);
      } else if (currentQuantityTotal < OfferRequiredQty && freeItemInCart) {
        Shopify.Cart.GiftWrapTag.removeGiftProduct(OfferQtyVariantId);
        console.log(`Global tag quantity gift removed for tag: ${offerTag}, quantity: ${OfferRequiredQty}`);
      }
    });
  });
}
document.addEventListener("cart:updated", () => {
  checkTagCond();
  checkTagQtyCond();
  checkGlobalTagGWPConditions();
  checkQuantityGlobalTagGWPConditions();
});

document.addEventListener("cart:add", () => {
  checkTagCond();
  checkTagQtyCond();
  checkGlobalTagGWPConditions();
  checkQuantityGlobalTagGWPConditions();
});

document.addEventListener("cart:change", () => {
  checkTagCond();
  checkTagQtyCond();
  checkGlobalTagGWPConditions();
  checkQuantityGlobalTagGWPConditions();
});

document.addEventListener("cart:remove", () => {
  checkTagCond();
  checkTagQtyCond();
  checkGlobalTagGWPConditions();
  checkQuantityGlobalTagGWPConditions();
;});

document.addEventListener("cart:refresh", () => {
  checkTagCond();
  checkTagQtyCond();
  checkGlobalTagGWPConditions();
  checkQuantityGlobalTagGWPConditions();
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('form[action^="/cart/add"]').forEach(function(form) {
      form.addEventListener('submit', function (event) {
        setTimeout(() => {
          checkTagCond();
          checkTagQtyCond();
          checkGlobalTagGWPConditions();
          checkQuantityGlobalTagGWPConditions();
        }, 1500);
      });
    });
});
  
checkTagCond();
checkTagQtyCond();
checkGlobalTagGWPConditions();
checkQuantityGlobalTagGWPConditions();